export default "__VITE_ASSET__D6A2b$VC__"